import { NodeFragment } from 'services/apollo/fragments';
import gql from 'graphql-tag';

export const NodeQuery = gql`
  query getNode($nodeId: String!) {
    nodeById(id: $nodeId) {
      ...nodeFragmentResults
    }
  }
  ${NodeFragment}
`;

export const ShareButtonQuery = gql`
  query getShareButton {
    me {
      organization {
        id
        name
        type
      }
    }
  }
`;

export const SharingRefetchQuery = gql`
  query getSharingRefetch($nodeId: String!, $includeGroups: Boolean!) {
    me {
      organization {
        id
        name
        type
      }
    }
    nodeById(id: $nodeId) {
      ... on Node {
        id
        accessorInfo(includeGroups: $includeGroups) {
          accessors {
            ... on Group {
              id
              emoji
              groupName: name
            }
            ... on Person {
              id
              name
              email
              avatarUrl
            }
          }
          pageInfo {
            endCursor
            hasNextPage
            total
          }
        }
        shareTargets {
          nodeId @client
          groupTargets(first: 200) {
            nodeId @client
            targets {
              ... on ShareTargetGroup {
                __typename
                id
                emoji
                groupName: name
              }
              nodeId
            }
            pageInfo {
              total
            }
          }
          orgPeopleTargets(first: 200) {
            nodeId @client
            targets {
              ... on Person {
                __typename
                id
                name
                avatarUrl
              }
              nodeId @client
              isOrgMember
            }
            pageInfo {
              total
            }
          }
          otherPeopleTargets(first: 200) {
            nodeId @client
            targets {
              ... on Person {
                __typename
                id
                name
                avatarUrl
              }
              nodeId @client
              isOrgMember
            }
            pageInfo {
              total
            }
          }
          __typename
        }
      }
    }
  }
`;
